import React from 'react';
import { Plus } from 'lucide-react';
import { motion } from 'framer-motion';

export default function FAB({ onClick }) {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      className="fixed bottom-24 sm:bottom-6 right-6 z-40 bg-slate-900 dark:bg-white text-white dark:text-slate-900 p-4 rounded-full shadow-xl transition-colors flex items-center justify-center group"
    >
      <Plus className="w-6 h-6 stroke-[2.5] group-hover:rotate-90 transition-transform duration-300" />
    </motion.button>
  );
}
